import axios from '../../utils/axios';

/**
 * change user language
 *  */
export const changeUserLangauge = async (id: number) =>
  await axios.post(`account/changeLanguage/${id}`);
